import { useState } from "react";
import { http, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await http.post("/leads/newsletter", { email });
      toast.success("You're on the list. Watch your inbox.");
      setEmail("");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="mt-32 border-t hairline" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-display-ai text-3xl font-black tracking-tight">
            AI CREATOR <span className="text-[#00FFC2]">OS</span>
          </div>
          <p className="mt-4 text-gray-400 max-w-md leading-relaxed">
            An AI Academy and a Media Studio under one roof. We teach the operators
            and we run the playbooks.
          </p>
          <form onSubmit={subscribe} className="mt-8 flex gap-2 max-w-md" data-testid="footer-newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="footer-newsletter-input"
              className="flex-1 bg-white/5 border hairline px-4 py-3 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-[#00FFC2]/60 rounded-md"
            />
            <button
              disabled={busy}
              data-testid="footer-newsletter-submit"
              className="btn-mint px-5 py-3 rounded-md text-sm"
            >
              {busy ? "..." : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4">Academy</div>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="/academy" className="hover:text-white">Overview</a></li>
            <li><a href="/academy/courses" className="hover:text-white">Modules</a></li>
            <li><a href="/academy/prompts" className="hover:text-white">Prompt Lab</a></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4">Studio</div>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="/studio" className="hover:text-white">Edit Bae Studios</a></li>
            <li><a href="/studio#work" className="hover:text-white">Case Studies</a></li>
            <li><a href="/studio#book" className="hover:text-white">Book a Call</a></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="label-eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="/blog" className="hover:text-white">Journal</a></li>
            <li><a href="/studio#book" className="hover:text-white">Contact</a></li>
            <li className="text-gray-500">studio@theaicreatoros.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t hairline py-6 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} AI Creator OS · Edit Bae Studios is the creative studio of AI Creator OS.
      </div>
    </footer>
  );
}
